import { parseDroplinkParam } from 'src/shared/shared.service';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { C20CTAContentCardsProps } from './C20CTAContentCards';
import { C20CTAContentCardProps } from './C20CTAContentCard';
import { CTA_CONTENT_CARDS } from 'src/shared/static';
import { CtaContentCardProps, CtaContentCardsProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getCheckbox } from 'src/shared/param-utils';

export function CreateCTAContentCardsModel(props?: C20CTAContentCardsProps) {
  const { renderRichText, renderLink, renderText } = useConditionalRendering();
  const headlineTag = props?.params?.TitleType
    ? (parseDroplinkParam(props?.params?.TitleType)?.value
        ?.value as CtaContentCardsProps['headlineTag'])
    : 'p';
  const numColumns = props?.params?.NumberOfColumns
    ? (parseDroplinkParam(props?.params?.NumberOfColumns)?.value
        ?.value as CtaContentCardsProps['numColumns'])
    : '2';
  const contentAlignment = props?.params?.ContentAlignment
    ? (parseDroplinkParam(props?.params?.ContentAlignment)?.value
        ?.value as CtaContentCardsProps['contentAlignment'])
    : 'center';
  const backgroundColor = props?.params?.BackgroundColor
    ? (parseDroplinkParam(props?.params?.BackgroundColor)?.value
        ?.value as CtaContentCardsProps['backgroundColor'])
    : 'white';
  const hasDropShadows = !!props?.params?.EnableDropshadow;
  const model: CtaContentCardsProps = {
    headline: renderText(props?.fields?.Headline),
    supportingCopy: renderRichText(props?.fields?.SupportCopy),
    bottomSupportingCopy: renderRichText(props?.fields?.BottomSupportCopy),
    cta: renderLink(props?.fields?.CTA),
    headlineTag,
    numColumns: numColumns,
    contentAlignment: contentAlignment,
    backgroundColor: backgroundColor,
    hasDropShadows: hasDropShadows,
    contentCards: props?.rendering ? (
      <Placeholder name={CTA_CONTENT_CARDS} rendering={props.rendering} />
    ) : (
      <></>
    ),
  };

  return model;
}

export function CreateCTAContentCardModel(props?: C20CTAContentCardProps) {
  const { renderRichText, renderImage, renderLink, renderText } = useConditionalRendering();
  const headlineTag = props?.params?.TitleType
    ? (parseDroplinkParam(props?.params?.TitleType)?.value
        ?.value as CtaContentCardProps['headlineTag'])
    : 'p';
  const firstCtaStyle = props?.params?.FirstCTAStyle
    ? (parseDroplinkParam(props?.params?.FirstCTAStyle)?.value
        ?.value as CtaContentCardProps['firstCtaStyle'])
    : 'button';
  const secondCtaStyle = props?.params?.SecondCTAStyle
    ? (parseDroplinkParam(props?.params?.SecondCTAStyle)?.value
        ?.value as CtaContentCardProps['secondCtaStyle'])
    : 'button';
  const ctaAlignment = props?.params?.CTAAlignment
    ? (parseDroplinkParam(props?.params?.CTAAlignment)?.value
        ?.value as CtaContentCardProps['ctaAlignment'])
    : 'center';
  const model: CtaContentCardProps = {
    headlineTag,
    firstCtaStyle: firstCtaStyle,
    secondCtaStyle: secondCtaStyle,
    ctaAlignment: ctaAlignment,
    headline: renderText(props?.fields?.Headline),
    bodyCopy: renderRichText(props?.fields?.BodyCopy),
    firstCta: renderLink(props?.fields?.FirstCTA),
    secondCta: renderLink(props?.fields?.SecondCTA),
    thirdCta: renderLink(props?.fields?.ThirdCTA),
    image: renderImage(props?.fields?.CardImage),
    shouldLazyLoad: getCheckbox(props?.params?.ShouldLazyLoad),
  };

  return model;
}
